import * as Yup from 'yup';

/**
 * @interface IBafModel
 * Backend'den gelen BafDTO'ya karşılık gelen TypeScript modeli.
 */
export interface IBafModel {
    id: string,
  // BAF Operation Date
  operationDate: string;

  // Departure Information
  departureDate: string;
  departureTime: string;
  departureBranch: string;
  departureKm: number;
  departureFuel: number;

  // Return Information
  returnDate: string;
  returnTime: string;
  returnBranch: string;
  returnKm: number;
  returnFuel: number;

  // Personnel Information
  personnelName: string;
  personnelSurname: string;
  processedByFullName: string;
  approvedByFullName: string;

  // Vehicle Information
  vehicleType: string;

  // Operation Details
  userPurpose: string;
  status: string;
  description: string;

  rentable: boolean;
}

/**
 * IBafModel için başlangıç değerleri.
 */
export const initialBafModel: IBafModel = {
  id: '',
  operationDate: '',
  departureDate: '',
  departureTime: '',
  departureBranch: '',
  departureKm: 0,
  departureFuel: 0,
  returnDate: '',
  returnTime: '',
  returnBranch: '',
  returnKm: 0,
  returnFuel: 0,
  personnelName: '',
  personnelSurname: '',
  processedByFullName: '',
  approvedByFullName: '',
  vehicleType: '',
  userPurpose: '',
  status: '',
  description: '',
  rentable: false,
};

/**
 * IBafModel için Yup doğrulama şeması.
 * Gerekli alanları ve tarih/saat formatlarını doğrular.
 */
export const validationBafSchema = Yup.object().shape({
  operationDate: Yup.string().required('İşlem tarihi zorunludur.'),
  
  departureDate: Yup.string().required('Çıkış tarihi zorunludur.'),
  departureTime: Yup.string().required('Çıkış saati zorunludur.'),
  departureBranch: Yup.string().required('Çıkış şubesi zorunludur.'),
  departureKm: Yup.number()
    .required('Çıkış KM bilgisi zorunludur.')
    .min(0, 'Çıkış KM negatif olamaz.'),
  departureFuel: Yup.number()
    .required('Çıkış yakıt bilgisi zorunludur.')
    .min(0, 'Çıkış yakıt bilgisi negatif olamaz.'),

  returnDate: Yup.string()
    .required('Dönüş tarihi zorunludur.')
    .test('is-after-departure', 'Dönüş tarihi, çıkış tarihinden sonra olmalı', function (value) {
      const { departureDate } = this.parent;
      return !departureDate || !value || new Date(value) >= new Date(departureDate);
    }),
  returnTime: Yup.string().required('Dönüş saati zorunludur.'),
  returnBranch: Yup.string().required('Dönüş şubesi zorunludur.'),
  returnKm: Yup.number()
    .required('Dönüş KM bilgisi zorunludur.')
    .min(0, 'Dönüş KM negatif olamaz.')
    .test('is-greater-than-departure', 'Dönüş KM, çıkış KM’den büyük olmalı', function (value) {
      const { departureKm } = this.parent;
      return !departureKm || !value || value >= departureKm;
    }),
  returnFuel: Yup.number()
    .required('Dönüş yakıt bilgisi zorunludur.')
    .min(0, 'Dönüş yakıt bilgisi negatif olamaz.'),

  //personnelName: Yup.string().required('Personel adı zorunludur.'),
  //personnelSurname: Yup.string().required('Personel soyadı zorunludur.'),
  //processedByFullName: Yup.string().required('İşlemi yapan kişi zorunludur.'),
  //approvedByFullName: Yup.string().required('Onaylayan kişi zorunludur.'),
  
  //vehicleType: Yup.string().required('Araç tipi zorunludur.'),

  userPurpose: Yup.string().required('Kullanım amacı zorunludur.'),
  status: Yup.string().required('Durum bilgisi zorunludur.'),
  description: Yup.string(),
});


export const USER_PURPUSE = [
  {value: 'Yer Değişikliği', label: 'Yer Değişikliği'},
  {value: 'TESLIM', label: 'Teslim'},
  {value: 'DİĞER', label: 'Diğer'},
] as const

export const STATUS_OPTION = [
    {value: 'Devam Ediyor',label: 'Devam Ediyor'},
    {value: 'Bitti' , label: 'Bitti'},
    {value: 'İptal Edildi', label: 'İptal Edildi'},
] as const

export const APPROVED_NAME = [
    {value: 'Selami Çetin',label: 'Selami Çetin'},

]